import script from "./HonorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HonorForm.vue?vue&type=script&setup=true&lang=js"

import "./HonorForm.vue?vue&type=style&index=0&id=7fb5c9ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb5c9ac"]])

export default __exports__